<div *ngIf="calculation" class="unit-calc">
    <div *ngIf="amountHeader || unitCostHeader || totalHeader" class="row headers">
        <div class="col-xs-6 amount-header">
            {{ amountHeader }}
        </div>
        <div class="col-xs-6 unit-cost-header">
            {{ unitCostHeader }}
        </div>
        <div class="col-xs-6 total-header">
            {{ totalHeader }}
        </div>
    </div>
    <div class="values">
        <div class="amount-div">
            {{ amountPrefix }}
            <input #amountBox (change)="onAmountChange(amountBox.value)" (focusin)="onFocus()"
                   (keyup)="onAmountChange(amountBox.value)" [(ngModel)]="calculation.amount"
                   [disabled]="disabled"
                   [ngClass]="{'empty': !calculation.amount}" class="amount-input"
                   min="0" name="amount"
                   placeholder="0" step="1" type="number"/>
            {{ amountSuffix }}
        </div>
        <div class="unit-cost-div">
            <span class="unit-cost">
                x
                {{ unitPrefix }}
                <span *ngIf="!unitCostEditable">
                    {{ calculation?.unitCost }}
                </span>
                <input #unitCostBox (change)="onUnitCostChange(unitCostBox.value)"
                       (keyup)="onUnitCostChange(unitCostBox.value)" *ngIf="unitCostEditable"
                       [(ngModel)]="calculation.unitCost" [disabled]="disabled"
                       [ngClass]="{'empty': !calculation.unitCost}" class="unit-cost-input"
                       min="0" name="unitCost"
                       placeholder="0" step="1" type="number"/>
                {{ unitSuffix }}
            </span>
        </div>
        <div class="result-div">
            <span class="total">
                =
                <span [ngClass]="{'significant': calculation.total && calculation.total != '0'}" class="inner-total">
                    {{ unitPrefix }}
                    {{ calculation?.total }}
                    {{ unitSuffix }}
                </span>
            </span>
        </div>
    </div>
</div>
